<template>
  <div class="relative max-w-full" >
    <div
      ref="contentRef"
      class="truncate"
      :class="props.textClass"
      :title="isTruncated ? String(props.value) : undefined"
      :style="{ maxWidth: props.maxWidth }"
      @mouseenter="checkTruncation"
    >
      {{ props.value }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    value: string | number | null | undefined;
    maxLength?: number;
    maxWidth?: string;
    textClass?: string;
  }>(),
  {
    maxLength: 100,
    maxWidth: '300px',
    textClass: 'text-[14px]',
  }
);

const contentRef = ref<HTMLElement | null>(null);
const isTruncated = ref(false);

const displayValue = computed(() => {
  if (props.value === null || props.value === undefined) return '';
  return String(props.value);
});

// Whether the text is cut off is only needed for the tooltip, so it is measured when the pointer enters the cell.
// Measuring every cell on mount (scrollWidth / clientWidth) forced one layout per cell: a grid of ~1,600 cells
// (Detailed Contract, 36 rows x ~45 columns) spent ~10 s in layout and garbage collection before it showed.
// A new value resets the flag; the next hover measures again.
watch(() => props.value, () => {
  isTruncated.value = false;
});

function checkTruncation() {
  if (contentRef.value) {
    isTruncated.value = contentRef.value.scrollWidth > contentRef.value.clientWidth;
  }
}
</script>

<style scoped>
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
